import { Button, Stack } from "@mui/material";
import { chunk } from "lodash-es";

import type { PollButtonProps } from "../../../utils/convert-to-mjml/poll-buttons/types";
import type { FC } from "react";

export const HorizontalPollOptions: FC<Omit<PollButtonProps, "align">> = ({
  buttonType,
  options,
  buttonWidth,
  paperSize,
}) => {
  // Split the options into the number of needed rows based on the paper size
  const buttonsPerRow = Math.floor((paperSize - 50) / buttonWidth);
  const buttonRows = chunk(options, buttonsPerRow);

  return (
    <>
      {buttonRows.map((row, index) => (
        <Stack direction="row" spacing={1} key={index}>
          {row.map((option) => (
            // oxlint-disable-next-line ce/require-button-id
            <Button
              className={buttonType}
              key={option.text}
              sx={{ cursor: "default", width: buttonWidth }}
            >
              {option.text}
            </Button>
          ))}
        </Stack>
      ))}
    </>
  );
};
